module.exports = __webpack_public_path__ + "img/default-goods.659cfebb.png";